import React, { useState } from "react";
import Navbar from "../../Components/Navbar";
import HeroSection from "./HeroSection";
import ExpertiseSection from "./ExpertiseSection";
import FeaturedProjectsSection from "./FeaturedProjectsSection";
import WhyChooseAbilioSection from "./WhyChooseAbilioSection";
import RealEstateSearch from "./RealEstateSearch";
import TestiMonialsSection from "./TestiMonialsSection";
import ContactQuoteSection from "./Contact & QuoteSection";
import Footer from "./Footer";
// import IntroAnimation from "../../Components/IntroAnimation";
import ScrollToTopButton from "../../Components/ScrollToTopButton";
import { Box } from "@mui/material";
import useMetaTags from "../../Hooks/UseMetaTags";

const Home = () => {
  useMetaTags({
    title: "Abilio Realty | Premium Real Estate & Construction Services",
    description: "Discover luxury residences, custom interior designs, and landmark construction developments with Abilio Realty. Find your perfect space today.",
    keywords: "abilio realty, luxury homes, premium apartments, real estate development, home construction, interior design, Noida, Delhi, Gurugram",
    ogTitle: "Abilio Realty | Premium Real Estate & Construction Services",
    ogDescription: "Discover luxury residences, custom interior designs, and landmark construction developments with Abilio Realty.",
  });

  const [showIntro, setShowIntro] = useState(false);

  const handleIntroComplete = () => {
    setShowIntro(false);
  };

  return (
    <>
      {/* {showIntro && <IntroAnimation onComplete={handleIntroComplete} />} */}
      <Box sx={{ minHeight: "100vh", backgroundColor: "#F9FAFB" }}>
      <Navbar />
      <HeroSection />
      <ExpertiseSection />
      <FeaturedProjectsSection />
      <WhyChooseAbilioSection />
      <RealEstateSearch />
      <TestiMonialsSection />
      <ContactQuoteSection />
      <Footer />
      <ScrollToTopButton />
      </Box>
    </>
  );
};

export default Home;
